import React from 'react';
import {LessonItem} from "features/model/types/student-info/studentInfoLessonsShema";
import {ReactComponent as ArrayIcon} from '../../../../../../../../../assets/main/groups/main-table/array.svg';
import {ReactComponent as CloseIcon} from '../../../../../../../../../assets/main/groups/online/cross.svg';
import {ReactComponent as CloseTwoIcon} from '../../../../../../../../../assets/main/groups/students/CloseTwoIcon.svg';
import {
    ReactComponent as FulfilledIcon
} from '../../../../../../../../../assets/main/groups/students/FulfilledIcon.svg';
import {
    ReactComponent as FulfilledTwoIcon
} from '../../../../../../../../../assets/main/groups/students/FulfilledTwoIcon.svg';
import {NavLink, useParams} from "react-router-dom";

interface IStudentsLessonsItems {
    lesson: LessonItem;
}

export const StudentsLessonsItems = ({lesson}: IStudentsLessonsItems) => {
    const {groupId} = useParams();

    return (
        <div className="row">
            <div className="col presence-col">
                <span className="col-title">Присутствие</span>
                <span className="presence-icon">
                    {lesson.attended ? <FulfilledIcon/> : <CloseIcon/>}
                </span>
            </div>
            <div className="col lesson-col auto-width full-width-mobile">
                <span className="col-title">Занятие</span>
                <p>
                    <NavLink style={{borderBottom: 'none', textShadow: 'none'}}
                             to={`/groups/${groupId}/lessons/${lesson.id}`}>{lesson.title}
                    </NavLink>
                </p>
                <span className="homework-status">
                    Домашнее задание{' '}
                    {lesson.hasHomework ?
                        <span className="complited-count icon-view">
                            <FulfilledTwoIcon/>
                        </span>
                        :
                        <span className="complited-count not-done icon-view">
                            <CloseTwoIcon/>
                        </span>
                    }
                </span>

            </div>
            <div className="col status-col full-width-mobile">
                <span className="col-title">Статус</span>
                {lesson.status === 'new' ? (
                    <p className="status-item">Новое</p>
                ) : lesson.status === 'inProgress' ? (
                    <p className="status-item in-progress">Занятие идёт</p>
                ) : (
                    <p className="status-item completed">Завершено</p>
                )}
            </div>
            <div className="col lessont-time-col auto-width">
                <span className="col-title">Время занятия</span>
                <time className="time">{lesson.date}</time>
            </div>
            <div className="col btn-link-col">
                <NavLink className="circle-arrow-btn" to={`/groups/${groupId}/lessons/${lesson.id}`}>
                    <ArrayIcon/>
                </NavLink>
            </div>
        </div>
    );
};
